import React from 'react';

const AttributeModelContext = React.createContext([]);
export default AttributeModelContext;
